import { Button, makeStyles, Title1, tokens } from '@fluentui/react-components';
import { AuthProvider, useAuth } from '@warehouselogix/web-common';

import { AdminShell } from './AdminShell';

const useStyles = makeStyles({
  signIn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacingVerticalL,
    minHeight: '100vh',
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
  },
});

/**
 * Sign-in prompt shown when no account is present. Lives inside the MSAL
 * provider (so {@link useAuth} works) but outside the authenticated shell.
 */
function SignInPrompt(): JSX.Element {
  const styles = useStyles();
  const { login } = useAuth();

  return (
    <main className={styles.signIn}>
      <Title1>WarehouseLogix Admin</Title1>
      <p>Please sign in to continue.</p>
      <Button appearance="primary" onClick={() => void login()}>
        Sign in
      </Button>
    </main>
  );
}

/** Auth gate: signed in → the admin shell; otherwise the sign-in prompt. */
function AuthGate(): JSX.Element {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? <AdminShell /> : <SignInPrompt />;
}

/**
 * Application root for the admin console. Establishes the MSAL auth context
 * (via @warehouselogix/web-common) and hands off to the auth gate.
 */
export function AdminApp(): JSX.Element {
  return (
    <AuthProvider>
      <AuthGate />
    </AuthProvider>
  );
}
